import React, { Component } from 'react';
import sectiondata from '../../data/sections.json';
import parse from 'html-react-parser';

class Mission extends Component {


    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'
        let data = sectiondata.mission


   return (
  
  <div className="mission-vission-area pd-top-40 pd-bottom-70" style={{ background: "#fff", padding: "60px 0" }}>
    
   
    <div className="container">
      <h1 style={{fontSize:"30px" , paddingBottom:"20px"}}>
        About Trinest Sky Real Estate
      </h1>
      <h2 style={{fontSize:"30px" , paddingBottom:"20px"}}>Who We Are</h2>
      <p style={{fontSize:"20px" , paddingBottom:"20px"}}>Trinest Sky Real Estate is a premier real estate agency based in Dubai, specializing in off-plan properties, luxury homes, and smart investment opportunities across the UAE’s most desirable locations. We connect clients from around the globe with world-class developments and exclusive property deals in Dubai’s thriving real estate market.</p>
      <div className="row" style={{ 
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "stretch",
        gap: "30px"
      }}>
        {data.items.map((item, i) => (
          <div key={i} style={{ 
            flex: "1",
            minWidth: "250px",
            padding: "0 15px",
            borderLeft: i > 0 ? "1px solid #eee" : "none"
          }}>
            <div className="details" style={{ height: "100%" }}>
              <h4 className="title" style={{
                fontSize: "20px",
                marginBottom: "15px",
                color: "#222",
                fontWeight: "600",
                position: "relative",
                paddingLeft: "20px"
              }}>
                <a href="#" style={{
                  color: "inherit",
                  textDecoration: "none"
                }}>
                  <span style={{
                    position: "absolute",
                    left: "0",
                    top: "0",
                    color: "#ff6b00"
                  }}>▸</span>
                  {item.title}
                </a>
              </h4>
              <p style={{
                color: "#555",
                lineHeight: "1.7",
                fontSize: "16px"
              }}>{item.content}</p>
            </div>
          </div>
        ))}
      </div>
      
      <div style={{ 
        marginTop: "50px",
        paddingTop: "30px",
        borderTop: "1px solid #eee"
      }}>
        <p style={{
          fontSize: "17px",
          color: "#444",
          lineHeight: "1.7",
          marginBottom: "15px",
          display: "flex",
          alignItems: "flex-start"
        }}>
          <i className="fa fa-check" style={{
            fontSize: "19px",
            color: "orange",
            marginRight: "12px",
            marginTop: "4px",
            flexShrink: "0"
          }}></i>
          Over the years, we've grown into a recognized brand by focusing on personalized service, expert market insights, and strong relationships with top-tier developers like EMAAR, DAMAC, Sobha, and more.
        </p>
        <p style={{
          fontSize: "17px",
          color: "#444",
          lineHeight: "1.7",
          marginBottom: "0",
          display: "flex",
          alignItems: "flex-start"
        }}>
          <i className="fa fa-check" style={{
            fontSize: "19px",
            color: "orange",
            marginRight: "12px",
            marginTop: "4px",
            flexShrink: "0"
          }}></i>
          Whether you're looking to buy your dream home, secure a high-ROI investment, or explore Dubai's off-plan opportunities, our team is here to guide you every step of the way.
        </p>
      </div>
      <div className="row" style={{ maxWidth: '1000px', margin: '0 auto',paddingTop:"20px" }}>
          {/* What We Offer Column */}
          <div className="col-md-6">
            <div className="service-section" style={{ padding: '20px' }}>
              <h3 className="section-title" style={{
                fontSize: '22px',
                fontWeight: '600',
                color: '#333',
                marginBottom: '20px',
                textAlign:"left",
                borderBottom: '1px solid #eee'
              }}>
                What We Offer
              </h3>
              
              <div className="service-list">
                <div className="service-item" style={{  borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontWeight: '500' }}>Off-Plan Property Sales</span>
                </div>
                <div className="service-item" style={{  borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontWeight: '500' }}>Premium Residential & Commercial Listings</span>
                </div>
                <div className="service-item" style={{ borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontWeight: '500' }}>Investment Consultation & Portfolio Building</span>
                </div>
                <div className="service-item" style={{borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontWeight: '500' }}>Property Management & After-Sales Support</span>
                </div>
                <div className="service-item">
                  <span style={{ fontWeight: '500' }}>Partnerships with Leading Developers in Dubai</span>
                </div>
              </div>
            </div>
          </div>

          {/* Why Choose Us Column */}
          <div className="col-md-6">
            <div className="service-section" style={{ padding: '20px' }}>
              <h3 className="section-title" style={{
                fontSize: '22px',
                fontWeight: '600',
                color: '#333',
                marginBottom: '20px',
                borderBottom: '1px solid #eee'
              }}>
                Why Choose Us
              </h3>
              
              <div className="service-list">
                <div className="service-item" style={{ borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontWeight: '500' }}>Deep expertise in Dubai's real estate market</span>
                </div>
                <div className="service-item" style={{ borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontWeight: '500' }}>Strong network of trusted developers</span>
                </div>
                <div className="service-item" style={{ borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontWeight: '500' }}>Multilingual and culturally diverse team</span>
                </div>
                <div className="service-item" style={{ borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontWeight: '500' }}>End-to-end client support—from inquiry to key handover</span>
                </div>
                <div className="service-item">
                  <span style={{ fontWeight: '500' }}>Proven track record of helping investors succeed</span>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
);

        }
}

export default Mission